import { pageTitle } from 'ember-page-title';
import { t } from 'ember-intl';
import { transitionTo } from 'pds-witsmlstudio-core/helpers';
import { Account } from 'pds-witsmlstudio-core/components';
import PageLayout from '../components/page-layout';

<template>
  {{pageTitle (t "account.title")}}

  <PageLayout>
    <:content>
      <Account @onClose={{transitionTo "index"}} />
    </:content>
  </PageLayout>
</template>
